// A meerkat, modelled facing +X: a slender upright tan body standing sentinel, a
// pointed dark-eyed face and a thin tail. Ported 1:1 from age-of-mcp's classic
// meerkat.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.022, 0), color: "#c2a474",
      position: [0, 0.05, 0], scale: [0.8, 1.5, 0.8] },             // upright body
    { geometry: new THREE.IcosahedronGeometry(0.016, 0), color: "#cdb080",
      position: [0.004, 0.09, 0] },                                  // head
    { geometry: new THREE.ConeGeometry(0.007, 0.018, 4), color: "#b89868",
      position: [0.018, 0.086, 0], rotation: [0, 0, -Math.PI / 2] },   // snout
    { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#1a1410",
      position: [0.014, 0.096, 0.008] },                            // eye patch
    { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#1a1410",
      position: [0.014, 0.096, -0.008] },
    { geometry: new THREE.IcosahedronGeometry(0.014, 0), color: "#dcc498",
      position: [0.008, 0.05, 0], scale: [0.6, 1.2, 0.7] },         // pale belly
    { geometry: new THREE.CylinderGeometry(0.004, 0.002, 0.05, 4), color: "#b89868",
      position: [-0.022, 0.03, 0], rotation: [0, 0, 0.8] },         // thin tail
  ];
}

export const meerkat = defineModel({
  id: "meerkat",
  batchId: "standard",
  name: "Meerkat",
  tags: ["creature","meerkat","low-poly","age-of-mcp","classic"],
  summary: "Low-poly meerkat.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.05,
  parts: () => partsFor(),
  animations: [],
});
